import { render, staticRenderFns } from "./PorEquipeAcs.vue?vue&type=template&id=2d541212&scoped=true"
import script from "./PorEquipeAcs.vue?vue&type=script&lang=js"
export * from "./PorEquipeAcs.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=2d541212&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d541212",
  null
  
)

export default component.exports